<div fxLayout="column" fxLayoutGap="15px">
    <div *ngFor="let control of getVisibleControls(); let i = index">
        <div [class.child-item]="isChildItem(control)" [style.margin-left.px]="isChildItem(control) ? 20 : 0">
            <app-user-setting-input
                type="switch"
                [showLabel]="i == 0"
                [control]="control.get('enabled') | cast"
                (onChange)="onToggleChange(control, $event)"
            >
                <span class="label" role="switch-label">
                    <span [class.child-label]="isChildItem(control)">
                        {{ getItemLabel(control.get('type').value, isChildItem(control)) }}
                    </span>
                    <span class="field-description">
                        {{ getItemDescription(control.get('type').value, isChildItem(control)) }}
                    </span>
                </span>
            </app-user-setting-input>
        </div>
    </div>

    <!-- Save button -->
    <div *ngIf="showSaveButton" fxLayout="row" fxLayoutAlign="start center">
        <button
            *ngIf="!loading"
            mat-raised-button
            color="primary"
            [disabled]="notificationForm.pristine"
            (click)="onSave()"
            i18n
        >
            {{ saveButtonText }}
        </button>
        <app-saving-button *ngIf="loading"></app-saving-button>
    </div>
</div>
